import { CalculationConfig } from '@calculations/types/calculation-config';
import { Decimal } from '@snap-types/types/decimal';

export type ContributionMarginCalculation = {
  unitPrice: Decimal;
  unitVariableCosts: Decimal;
  contributionMargin: Decimal;
};

export function calculateUnitPriceFromContributionMargin(
  {
    contributionMargin,
    unitVariableCosts,
  }: {
    unitVariableCosts: Decimal;
    contributionMargin: Decimal;
  },
  config: CalculationConfig,
): ContributionMarginCalculation {
  if (contributionMargin.gte(new Decimal('1'))) {
    throw new Error(
      'contributionMargin cannot be greater than or equal to "1"',
    );
  }

  const unitPrice = unitVariableCosts
    .dividedBy(new Decimal('1').minus(contributionMargin))
    .toDecimalPlaces(config.decimalPlaces);

  return {
    unitPrice,
    unitVariableCosts,
    contributionMargin,
  };
}

export function calculateContributionMarginFromUnitPrice(
  {
    unitPrice,
    unitVariableCosts,
  }: {
    unitVariableCosts: Decimal;
    unitPrice: Decimal;
  },
  config: CalculationConfig,
): Decimal {
  if (unitPrice.eq(new Decimal('0'))) {
    throw new Error('unitPrice cannot be "0"');
  }

  const contributionMargin = unitPrice
    .minus(unitVariableCosts)
    .dividedBy(unitPrice)
    .toDecimalPlaces(config.decimalPlaces);

  return contributionMargin;
}
